/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteChangeLogQueryVariables = Types.Exact<{
  docId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  filters?: Types.InputMaybe<Types.ChangeLogFilters>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type QuoteChangeLogQuery = { quoteChangeLog: { __typename: 'ChangeLogConnection', edges: Array<{ __typename: 'ChangeLogEntryEdge', cursor: string, node: { __typename: 'ChangeLogEntry', id: string, occurredAt: any, operation?: Types.ChangeLogOperation | null, entityType: string, field?: string | null, correlationId: string, actor: { __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }, entity: { __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }, oldValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null, newValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions', missingPermissions: Array<Types.PermissionName> } };

export type ChangeLogView_EntryFragment = { __typename: 'ChangeLogEntry', id: string, occurredAt: any, operation?: Types.ChangeLogOperation | null, entityType: string, field?: string | null, correlationId: string, actor: { __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }, entity: { __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }, oldValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null, newValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null };

export type QuoteChangeLogFacetsQueryVariables = Types.Exact<{
  docId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type QuoteChangeLogFacetsQuery = { quoteChangeLogFacets: { __typename: 'ChangeLogFacets', operations: Array<Types.ChangeLogOperation>, hasPureEvents: boolean, actors: Array<{ __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }>, entities: Array<{ __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions', missingPermissions: Array<Types.PermissionName> } };

export const ChangeLogView_EntryFragmentDoc = gql`
    fragment ChangeLogView_Entry on ChangeLogEntry {
  id
  occurredAt
  operation
  entityType
  field
  correlationId
  actor {
    actorId
    userId
    label
  }
  entity {
    entityId
    entityType
    name
    position
    isDeleted
    nameSpan {
      from
      till
      date
      durationMinutes
    }
  }
  oldValue {
    recorded
    value
    label
  }
  newValue {
    recorded
    value
    label
  }
}
    `;
export const QuoteChangeLogDocument = gql`
    query QuoteChangeLog($docId: ID!, $projectId: ID!, $filters: ChangeLogFilters, $first: Int, $after: String) {
  quoteChangeLog(
    docId: $docId
    projectId: $projectId
    filters: $filters
    first: $first
    after: $after
  ) {
    ... on ChangeLogConnection {
      edges {
        cursor
        node {
          ...ChangeLogView_Entry
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    ... on MissingPermissions {
      missingPermissions
    }
  }
}
    ${ChangeLogView_EntryFragmentDoc}`;

/**
 * __useQuoteChangeLogQuery__
 *
 * To run a query within a React component, call `useQuoteChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteChangeLogQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useQuoteChangeLogQuery(baseOptions: Apollo.QueryHookOptions<QuoteChangeLogQuery, QuoteChangeLogQueryVariables> & ({ variables: QuoteChangeLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>(QuoteChangeLogDocument, options);
      }
export function useQuoteChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>(QuoteChangeLogDocument, options);
        }
export function useQuoteChangeLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>(QuoteChangeLogDocument, options);
        }
export type QuoteChangeLogQueryHookResult = ReturnType<typeof useQuoteChangeLogQuery>;
export type QuoteChangeLogLazyQueryHookResult = ReturnType<typeof useQuoteChangeLogLazyQuery>;
export type QuoteChangeLogSuspenseQueryHookResult = ReturnType<typeof useQuoteChangeLogSuspenseQuery>;
export type QuoteChangeLogQueryResult = Apollo.QueryResult<QuoteChangeLogQuery, QuoteChangeLogQueryVariables>;
export const QuoteChangeLogFacetsDocument = gql`
    query QuoteChangeLogFacets($docId: ID!, $projectId: ID!) {
  quoteChangeLogFacets(docId: $docId, projectId: $projectId) {
    ... on ChangeLogFacets {
      actors {
        actorId
        userId
        label
      }
      entities {
        entityId
        entityType
        name
        position
        isDeleted
        nameSpan {
          from
          till
          date
          durationMinutes
        }
      }
      operations
      hasPureEvents
    }
    ... on MissingPermissions {
      missingPermissions
    }
  }
}
    `;

/**
 * __useQuoteChangeLogFacetsQuery__
 *
 * To run a query within a React component, call `useQuoteChangeLogFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteChangeLogFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteChangeLogFacetsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useQuoteChangeLogFacetsQuery(baseOptions: Apollo.QueryHookOptions<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables> & ({ variables: QuoteChangeLogFacetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>(QuoteChangeLogFacetsDocument, options);
      }
export function useQuoteChangeLogFacetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>(QuoteChangeLogFacetsDocument, options);
        }
export function useQuoteChangeLogFacetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>(QuoteChangeLogFacetsDocument, options);
        }
export type QuoteChangeLogFacetsQueryHookResult = ReturnType<typeof useQuoteChangeLogFacetsQuery>;
export type QuoteChangeLogFacetsLazyQueryHookResult = ReturnType<typeof useQuoteChangeLogFacetsLazyQuery>;
export type QuoteChangeLogFacetsSuspenseQueryHookResult = ReturnType<typeof useQuoteChangeLogFacetsSuspenseQuery>;
export type QuoteChangeLogFacetsQueryResult = Apollo.QueryResult<QuoteChangeLogFacetsQuery, QuoteChangeLogFacetsQueryVariables>;